import * as Sentry from '@sentry/vue'
import { App } from 'vue'

import type { Router } from 'vue-router'

export const SENTRY_ALLOWED_DOMAINS = [
  'preprod.oqtopus.fr',
  'demo.oqtopus.fr',
  'client.closd.com',
]

// See V2-5747 for context
export const SENTRY_REPORTED_STATUS_CODES = [400]

export function initSentry (app: App, router: Router) {
  // See V2-5638. Following the inclusion of the allowed domains on Sentry's side,
  // we should only initialize Sentry if the current domain is allowed.
  if (!SENTRY_ALLOWED_DOMAINS.includes(window.location.hostname)) {
    return
  }

  Sentry.init({
    app,
    dsn: import.meta.env.VUE_APP_SENTRY_DSN,
    // We could also have custom environments for local testing,
    // That way we could filter each local environment if multiple DSN isn't viable
    environment: import.meta.env.VUE_APP_SENTRY_ENVIRONNEMENT || 'local',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['closd-front'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],
    tracePropagationTargets: ['oqtopus.com', /^\//],
    tracesSampleRate: 0.2,
    release: `closd-front@${__APP_VERSION__}`,
    beforeSend(event, hint) {
      const error: any = hint?.originalException
      if (error?.isAxiosError) {
        const status = error.request?.status
        if (
          status < 500 &&
          !SENTRY_REPORTED_STATUS_CODES.includes(status) &&
          !error.message.includes('timeout')
        ) {
          return null
        }
      }
      return event
    },
  })

  Sentry.setTags({
    version: __APP_VERSION__,
    revision: __APP_REVISION__,
  })
}
